<template>
  <div class="phone-code">
    <input
      v-for="(_, index) in digits"
      :key="index"
      ref="inputs"
      :value="digits[index]"
      class="phone-code__input"
      type="text"
      inputmode="numeric"
      maxlength="1"
      autocomplete="one-time-code"
      :aria-label="`Цифра кода ${index + 1}`"
      @input="onInput(index, $event)"
      @keydown="onKeydown(index, $event)"
      @paste="onPaste"
    />
  </div>
</template>

<script>
export default {
  name: 'PhoneCodeCells',

  props: {
    modelValue: {
      type: String,
      default: '',
    },
    length: {
      type: Number,
      default: 4,
    },
  },

  emits: ['update:modelValue', 'complete'],

  computed: {
    digits() {
      const cleanValue = String(this.modelValue || '')
        .replace(/\D/g, '')
        .slice(0, this.length);

      return Array.from({ length: this.length }, (_, index) => cleanValue[index] || '');
    },
  },

  methods: {
    updateDigits(nextDigits) {
      const code = nextDigits.join('').replace(/\D/g, '').slice(0, this.length);

      this.$emit('update:modelValue', code);

      if (code.length === this.length) {
        this.$emit('complete', code);
      }
    },

    focusInput(index) {
      this.$nextTick(() => {
        this.$refs.inputs?.[index]?.focus();
      });
    },

    onInput(index, event) {
      const value = String(event.target.value || '').replace(/\D/g, '');
      const nextDigits = [...this.digits];

      if (value.length > 1) {
        value
          .slice(0, this.length - index)
          .split('')
          .forEach((digit, offset) => {
            nextDigits[index + offset] = digit;
          });

        this.updateDigits(nextDigits);
        this.focusInput(Math.min(index + value.length, this.length - 1));
        return;
      }

      nextDigits[index] = value.slice(-1);
      this.updateDigits(nextDigits);

      if (value && index < this.length - 1) {
        this.focusInput(index + 1);
      }
    },

    onKeydown(index, event) {
      if (event.key !== 'Backspace') return;

      const nextDigits = [...this.digits];

      if (nextDigits[index]) {
        nextDigits[index] = '';
        this.updateDigits(nextDigits);
        return;
      }

      if (index > 0) {
        this.focusInput(index - 1);
      }
    },

    onPaste(event) {
      event.preventDefault();

      const pasted = String(event.clipboardData?.getData('text') || '')
        .replace(/\D/g, '')
        .slice(0, this.length);

      const nextDigits = Array.from({ length: this.length }, (_, index) => pasted[index] || '');

      this.updateDigits(nextDigits);
      this.focusInput(Math.min(pasted.length, this.length - 1));
    },
  },
};
</script>

<style scoped>
.phone-code {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 54px));
  gap: 10px;
  justify-content: center;
}

.phone-code__input {
  width: 54px;
  height: 60px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.04);
  color: var(--text);
  font-size: 24px;
  font-weight: 800;
  text-align: center;
  outline: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.phone-code__input:focus {
  border-color: rgb(156 92 255 / 40%);
  box-shadow: 0 0 0 4px rgb(156 92 255 / 14%);
  background: rgba(255, 255, 255, 0.06);
}

@media (max-width: 420px) {
  .phone-code {
    grid-template-columns: repeat(4, minmax(0, 48px));
    gap: 8px;
  }

  .phone-code__input {
    width: 48px;
    height: 56px;
  }
}
</style>